module.exports = __webpack_public_path__ + "static/media/mail.25ec90ca.svg";